import type { Quote } from '@facture/contracts'
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { Skeleton } from '@/components/ui/skeleton'
import { QuoteEditor } from '@/features/quotes/quote-editor'
import { api } from '@/lib/api'

const quoteQuery = (id: string) =>
  queryOptions({ queryKey: ['quotes', 'detail', id], queryFn: () => api.get<Quote>(`/quotes/${id}`) })

export const Route = createFileRoute('/_app/quotes/$id')({
  staticData: { crumb: 'Detalle' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(quoteQuery(params.id)),
  pendingComponent: () => (
    <div className="mx-auto grid gap-6 px-8 py-8 xl:grid-cols-[1fr_380px]">
      <Skeleton className="h-[480px] rounded-xl" />
      <Skeleton className="h-[480px] rounded-xl" />
    </div>
  ),
  component: QuotePage,
})

function QuotePage() {
  const { id } = Route.useParams()
  const { data } = useSuspenseQuery(quoteQuery(id))
  return <QuoteEditor key={`${data.id}-${data.status}-${data.runs}`} kind={data.kind} quote={data} />
}
